import { render } from "./armazensView.vue?vue&type=template&id=84274130"
import script from "./armazensView.vue?vue&type=script&lang=js"
export * from "./armazensView.vue?vue&type=script&lang=js"

import "./armazensView.vue?vue&type=style&index=0&id=84274130&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__